<template>
  <div class="delete-member">
    <v-dialog v-model="dialog" max-width="450" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Delete Joe Shmoe?</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <div>
            <p>Joe Shmoe will permanently deleted from Project XYZ</p>

            <v-btn color="red" class="white--text mr-1" depressed>Delete</v-btn>
            <v-btn color="black" outlined depressed @click="$emit('close')"
              >Cancel</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>
